import axios from 'axios'
import {
  Message
} from 'element-ui'
import {
  l
} from "@/utils/tool";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// response interceptor
service.interceptors.response.use(
  response => {
    const code = response.data.code
    if (code === 200 || code === 0) {
      return response.data
    } else {
      Message({
        message: response.data.msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
  },
  error => {
    // Message({
    //   message: '抱歉，处理点问题',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    console.log('err' + error) // for debug
  }
)


//公司动态列表
export function dynamic_list(query) {
  return service({
    url: '/official_website/api/dynamic/list',
    method: 'get',
    params: query
  })
}
//打非列表
export function illegal_list(query) {
  return service({
    url: '/official_website/api/illegal/list',
    method: 'get',
    params: query
  })
}

//党建列表
export function party_list(query) {
  return service({
    url: '/official_website/api/party_construction/list',
    method: 'get',
    params: query
  })
}

//招聘列表
export function recruit_list(query) {
  return service({
    url: '/official_website/api/recruit/list',
    method: 'get',
    params: query
  })
}

//资讯栏目列表
export function cate_list(query) {
  return service({
    url: '/official_website/api/information/cate_list',
    method: 'get',
    params: query
  })
}

//资讯列表
export function information_list(query) {
  return service({
    url: '/official_website/api/information/list?cate_id=' + query,
    method: 'get',
    params: ''
  })
}

//投教中心专辑列表
export function tjzx_list(query) {
  return service({
    url: '/official_website/api/tjzx/cate_list?cate_type=' + query,
    method: 'get',
    params: ''
  })
}

//投教中心视频列表
export function tjzxVideo_list(id, page, limit) {
  return service({
    url: '/official_website/api/tjzx/list?cate_id=' + id + '&limit=' + limit + '&page=' + page,
    method: 'get',
    params: ''
  })
}

//html 动态
export function viewDT(query) {
  return service({
    url: '/official_website/api/dynamic/view?id=' + query,
    method: 'get',
    params: ''
  })
}

//html 打非
export function viewDF(query) {
  return service({
    url: '/official_website/api/illegal/view?id=' + query,
    method: 'get',
    params: ''
  })
}

//html 党建
export function viewDJ(query) {
  return service({
    url: '/official_website/api/party_construction/view?id=' + query,
    method: 'get',
    params: ''
  })
}

//html 招聘
export function viewZP(query) {
  return service({
    url: '/official_website/api/recruit/view?id=' + query,
    method: 'get',
    params: ''
  })
}


//html 资讯中心
export function viewZXZX(query) {
  return service({
    url: '/official_website/api/information/cate_list',
    method: 'get',
    params: ''
  })
}
//html 资讯列表
export function viewZXList(p, l, i) {
  return service({
    url: '/official_website/api/information/list?page=' + p + '&limit=' + l + '&cate_id=' + i,
    method: 'get',
    params: ''
  })
}
//html 资讯文章
export function viewZX(query) {
  return service({
    url: '/official_website/api/information/view?id=' + query,
    method: 'get',
    params: ''
  })
}
export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js